import { Permissions, Resources, UserRole } from './authTypes';

export const checkAccess = (role: UserRole, userPermissions: Array<Permissions>, resourceName: Resources): boolean => {
  let isAccessAllowed = false;

  if (userPermissions) {
    switch (resourceName) {
      case Resources.eTRF: // Role : InstitutionUser / OrdersUser - Permissions : CreateOrder
        if (role === UserRole.InstitutionUser || role === UserRole.OrdersUser) {
          if (userPermissions.includes(Permissions.CreateOrder)) isAccessAllowed = true;
        }
        break;
      case Resources.ordersListView: // Role : InstitutionUser / ResultsUser - Permissions : AccessResults
        if (role === UserRole.InstitutionUser || role === UserRole.ResultsUser) {
          if (userPermissions.includes(Permissions.AccessResults)) isAccessAllowed = true;
        }
        break;
      case Resources.kitOrdering: // Role : InstitutionUser / OrdersUser - Permissions : OrderKit
        if (role === UserRole.InstitutionUser || role === UserRole.OrdersUser) {
          if (userPermissions.includes(Permissions.OrderKit)) isAccessAllowed = true;
        }
        break;
      case Resources.users: // Role : InstitutionUser
        if (role === UserRole.InstitutionUser) {
          if (userPermissions.includes(Permissions.WriteOnInstitution)) isAccessAllowed = true;
        }
        break;
      default:
        break;
    }
  }
  return isAccessAllowed;
};
